import { Box, Theme } from "@outschool/backpack";
import { DeviceType } from "@outschool/ui-utils";
import React from "react";

import ContentfulPageLayout, {
  MetaTags
} from "../../components/contentful/ContentfulPageLayout";
import { MAX_WIDTH } from "./constants";

type LandingPageLayoutProps = {
  title: string;
  metaTags: MetaTags;
  deviceType: DeviceType;
};

export default function LandingPageLayout({
  title,
  metaTags,
  children,
  deviceType
}: React.PropsWithChildren<LandingPageLayoutProps>) {
  return (
    <ContentfulPageLayout
      deviceType={deviceType}
      title={title}
      metaTags={metaTags}
      trackingName="contentfulLandingPageImpression"
    >
      <Box
        sx={(theme: Theme) => ({
          minHeight: "1000px",
          maxWidth: MAX_WIDTH,
          margin: "2rem auto",
          marginX: "auto",
          paddingX: "1em",
          [theme.breakpoints.down("lg")]: {
            margin: "2rem auto",
            minHeight: "100%"
          }
        })}
      >
        {children}
      </Box>
    </ContentfulPageLayout>
  );
}
